import React, { ReactNode } from 'react';

import cn from 'classnames';

import Avatar from 'components/Avatar';
import Icon from 'components/Icon';

import styles from './CompanyCard.module.scss';

interface CompanyCardProps {
  name: string;
  icon: string;
  title: string;
  caption: string;
  isHuzzleVerified?: boolean;
  isVerified?: boolean;
  children?: ReactNode;
  onSelect?: () => void;
  className?: string;
}

export const CompanyCard: React.FC<CompanyCardProps> = (
  props: CompanyCardProps
) => {
  const {
    name,
    icon,
    title,
    caption,
    isHuzzleVerified,
    isVerified,
    children,
    onSelect,
    className: classes,
  } = props;

  return (
    <div className={cn(styles.companyCard, classes)}>
      <div className={styles.companyCardAvatar}>
        <Avatar
          icon={icon}
          name={name}
          altText={`Logo of ${name}`}
          size={'medium'}
        />
        {isHuzzleVerified && (
          <Icon
            iconName="icon_star"
            size={'auto'}
            className={styles.huzzleVerifiedIcon}
          />
        )}
        {isVerified && !isHuzzleVerified && (
          <Icon
            iconName="tick-mark-circle"
            size={'auto'}
            className={styles.verifiedIcon}
          />
        )}
      </div>
      <div className={styles.companyCardInfo}>
        <p
          className={cn(styles.title, { [styles.clickableTitle]: !!onSelect })}
          onClick={onSelect}
        >
          {title}
        </p>
        <p className={styles.caption}>{caption}</p>
      </div>
      {children && <div className={styles.companyCardAction}>{children}</div>}
    </div>
  );
};
